import { createMuiTheme, responsiveFontSizes, Theme } from '@material-ui/core/styles'
import createBreakpoints from '@material-ui/core/styles/createBreakpoints'
import { PaletteColorOptions, PaletteOptions } from '@material-ui/core/styles/createPalette'
import { getComponents } from './components'

const makeTheme = ({
  primary,
  fontFamily = 'Proxima Nova',
  headerFontFamily = 'Proxima Nova',
  radius = '0',
  themeColor = '#fff',
  themeBackgroundColor = '#000',
}: {
  primary: PaletteColorOptions
  fontFamily: string
  headerFontFamily: string
  radius: string
  themeColor: string
  themeBackgroundColor: string
}): Theme => {
  const palette: PaletteOptions = {
    type: 'light',
    primary,
    tertiary: {
      main: '#111',
    },
    quaternary: {
      main: '#EEE',
    },
    neutrals: {
      black: '#333333',
      mediumDark: '#828282',
      50: '#f7f7f7',
      100: '#edecec',
      200: '#e3e1e1',
      300: '#c7c4c4',
      400: '#9e9c9c',
      500: '#827f7f',
      600: '#696767',
      700: '#514f4f',
      800: '#383636',
      900: '#1f1e1e',
    },
    success: {
      50: '#f2faf5',
      100: '#dff2e7',
      200: '#cae9d7',
      300: '#9ed9b6',
      400: '#85cc9d',
      500: '#6fb881',
      600: '#4ba661',
      700: '#238c3d',
      800: '#0d5920',
      900: '#094017',
    },
    error: {
      50: '#faeeee',
      100: '#f6dcdc',
      200: '#ecb9ba',
      300: '#f19092',
      400: '#ee6d6d',
      500: '#e84649',
      600: '#ba383a',
      700: '#952527',
      800: '#641819',
      900: '#420f10',
    },
  }
  const breakpoints = createBreakpoints({})
  const components = getComponents(palette, breakpoints, radius, headerFontFamily, themeColor, themeBackgroundColor)
  const typography = {
    fontFamily: `${fontFamily}, sans-serif`,
    fontSize: 16,
  }
  return responsiveFontSizes(
    createMuiTheme({
      typography,
      palette,
      overrides: components,
    })
  )
}

export default makeTheme
